import React, { useState } from "react";
import "../styles/ProductTabs.scss";
import Logo from "../assets/logo.png";
import aquecedor1 from "../assets/produtos/aquecedor1.png";
import aquecedor2 from "../assets/produtos/aquecedor2.png";
import aquecedor3 from "../assets/produtos/aquecedor3.png";
import boiler1 from "../assets/produtos/boiler1.png";
import boiler2 from "../assets/produtos/boiler2.png";
import bomba1 from "../assets/produtos/bomba1.png";
import bomba2 from "../assets/produtos/bomba2.png";
import bomba3 from "../assets/produtos/bombap1.png";
import coletor1 from "../assets/produtos/coletor1.png";
import coletor2 from "../assets/produtos/coletor2.png";
import coletor3 from "../assets/produtos/coletor3.png";
import coletor4 from "../assets/produtos/coletor4.png";
import tp20 from "../assets/produtos/tp20.png";
import tp80 from "../assets/produtos/tp80.png";
import g4 from "../assets/produtos/g4.png";
import tp120 from "../assets/produtos/tp120.jpg";
import bkhome from "../assets/produtos/bk_home.png";
import bkhomew from "../assets/produtos/bk_homew.png";
import digital from "../assets/produtos/digital.png";
import digital2 from "../assets/produtos/digital2.png";
import digital3 from "../assets/produtos/digital2.png";
import externo from "../assets/produtos/externo.jpg";
import slim1 from "../assets/produtos/slim.jpg";
import slim2 from "../assets/produtos/slim2.png";
import tp820 from "../assets/produtos/tp820.png";
import up725 from "../assets/produtos/up725.png";
import aquajet from "../assets/produtos/aquajet.png";
import lona from "../assets/produtos/lona.png";
import pressurizador1 from "../assets/produtos/pressurizador1.png";
import pressurizador2 from "../assets/produtos/pressurizador2.png";
import tbhl from "../assets/produtos/tbhl.jpg";
import tpmini from "../assets/produtos/tpmini.jpg";
import smartpump from "../assets/produtos/smartpump.png";
import smart300 from "../assets/produtos/smart300.png";
import pressostato from "../assets/produtos/pressostato.png";
const productData = {
  Boilers: [
    {
      title: "Reservatório Vertical",
      description:
        "O novo reservatório térmico da Komeco foi projetado para oferecer a você a melhor experiência em aquecimento de água, com foco na praticidade e na durabilidade.",
      image: boiler1,
    },
    {
      title: "Reservatório Horizontal",
      description:
        "Armazene água quente por muito mais tempo e garanta seu banho de conforto e qualidade. Produto Personalizável (consulte nossa equipe para mais informações).",
      image: boiler2,
    },
  ],
  "Aquecedores a Gás": [
    {
      title: "Aquecedor a Gás KO 26SL Decor",
      description:
        "O Decor 26 é o primeiro e único do mercado com sistema de pressurização interna. Esse sistema inovador ELIMINA A NECESSIDADE DE INSTALAR UMA BOMBA DE ÁGUA ADICIONAL, simplificando a instalação e proporcionando economia.",
      image: aquecedor1,
    },
    {
      title: "Aquecedor a Gás KO 26BK Decor",
      description:
        "DESCUBRA A EVOLUÇÃO EM PERFORMANCE E DESIGN. O único do mercado com pressurização integrada, agora com 26 litros de vazão.",
      image: aquecedor2,
    },
    {
      title: "Aquecedor a Gás KO 26WH Decor",
      description:
        "Com sua tecnologia avançada, o aquecedor Decor oferece banhos ainda mais confortáveis e agradáveis, combinando alta pressão de água com a constância e precisão da temperatura escolhida.",
      image: aquecedor3,
    },
    {
      title: "KO 09B BK Home",
      description:
        "Aquecedor a gás Komeco Linha Home com fluxo balanceado, ideal para residências.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-09b-bk-home/",
      image: bkhome,
    },
    {
      title: "KO 09B WH Home",
      description: "Aquecedor a gás Komeco Linha Home branco, modelo 9 litros.",
      url: "",
      image: bkhomew,
    },
    {
      title: "KO 16BK Home",
      description:
        "Aquecedor a gás Komeco Linha Home 16L com exaustão forçada.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-16bk-home/",
      image: bkhome,
    },
    {
      title: "KO 16WH Home",
      description: "Aquecedor a gás Komeco Linha Home 16L branco.",
      url: "",
      image: bkhomew,
    },
    {
      title: "KO 21BK Home",
      description:
        "Aquecedor a gás Komeco Linha Home 21L com fluxo balanceado.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-21b-bk-home/",
      image: bkhome,
    },
    {
      title: "KO 21WH Home",
      description: "Aquecedor a gás Komeco Linha Home 21L branco.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-21wh-home/",
      image: bkhomew,
    },
    {
      title: "KO 26BK Home",
      description:
        "Aquecedor a gás Komeco Linha Home 26L com exaustão forçada.",
      url: "",
      image: bkhome,
    },
    {
      title: "KO 26WH Home",
      description: "Aquecedor a gás Komeco Linha Home 26L branco.",
      url: "",
      image: bkhomew,
    },
    {
      title: "KO 36BK Home",
      description: "Aquecedor a gás Komeco Linha Home 36L preto.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-36bk-home/",
      image: bkhome,
    },
    {
      title: "KO 36WH Home",
      description: "Aquecedor a gás Komeco Linha Home 36L branco.",
      url: "",
      image: bkhomew,
    },
    {
      title: "KO 09B DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital com painel touch e fluxo balanceado. 9 litros.",
      url: "",
      image: digital,
    },
    {
      title: "KO 16DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital 16L com exaustão forçada. 2024.",
      url: "",
      image: digital,
    },
    {
      title: "KO 21DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital 21L com exaustão forçada. 2024.",
      url: "",
      image: digital,
    },
    {
      title: "KO 26DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital 26L com exaustão forçada. 2024.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-26di-digital-2024/",
      image: digital,
    },
    {
      title: "KO 36DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital 36L com exaustão forçada. 2024.",
      url: "",
      image: digital,
    },
    {
      title: "KO 31DI Digital",
      description:
        "Aquecedor a gás Komeco Linha Digital 31L com painel touchscreen.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-31di-digital/",
      image: digital2,
    },
    {
      title: "KO 38DI Prime",
      description:
        "Aquecedor a gás Komeco Linha Prime 38DI em inox e alta performance.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-38di-prime/",
      image: digital3,
    },
    {
      title: "KO 33DI Prime",
      description: "Aquecedor a gás Komeco Linha Prime 33DI em inox.",
      url: "",
      image: digital3,
    },
    {
      title: "KO 26EX Externo",
      description:
        "Aquecedor a gás Komeco modelo externo KO 26EX, ideal para áreas abertas.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-26ex/",
      image: externo,
    },
    {
      title: "KO 12M Slim",
      description:
        "Aquecedor a gás Komeco Linha Slim 12M — compacto e eficiente.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-12m-slim/",
      image: slim1,
    },
    {
      title: "KO 15M Slim",
      description:
        "Aquecedor a gás Komeco Linha Slim 15M — compacto e versátil.",
      url: "https://www.komeco.com.br/aquecedor-a-gas-ko-15m-slim/",
      image: slim2,
    },
  ],

  "Bombas de Pressurização": [
    {
      title: "Bomba de Água Silent Press",
      description:
        "Equipadas com sistema misto – PRESSOSTATO E FLUXOSTATO – elas garantem o funcionamento contínuo mesmo em baixas vazões de água – vazão mín. 3~3,5 l/min. Motor desenvolvido com material de alta tecnologia proporcionando isolamento acústico.",
      image: pressurizador1,
    },
    {
      title: "Pressurizador de Água TP 820 / TP 825 – G2",
      description:
        "Proporciona maior aproveitamento do seu potencial hidráulico, ligando automaticamente apenas quando a pressão da rede está baixa. Conta com um pressostato que monitora e desliga o equipamento caso subpressão ou sobrepressão.",
      image: pressurizador2,
    },
    {
      title: "Pressurizador TP 820 / TP 825 G3",
      description:
        "Pressurizadores Komeco TP 820/825 com acionamento automático e alta eficiência para manter pressão constante na sua rede hidráulica.",
      image: tp820,
    },
    {
      title: "Bomba de Água Ultra Press 725",
      description:
        "Com meio cavalo de potência, a UP 725 é ideal para pressurização de residências conforme curva de desempenho. Perfeita para pressurização de redes hidráulicas, drenagem de reservatórios e sucção de água de poços.",
      image: up725,
    },
  ],
  "Coletores Solares": [
    {
      title: "Coletor Solar Tubo a Vácuo Baixa Pressão",
      description:
        "O Coletor Solar Tubo a Vácuo de Baixa Pressão é responsável por elevar a temperatura da água a um nível agradável para o banho, tornando possível desfrutar de um momento relaxante mesmo em temperaturas externas baixas.",
      image: coletor1,
    },
    {
      title: "Coletor Solar Tubo a Vácuo Alta Pressão",
      description:
        "O Coletor Solar Tubo a Vácuo de Alta Pressão é responsável por elevar a temperatura da água a um nível agradável para o banho, tornando possível desfrutar de um momento relaxante mesmo em temperaturas externas baixas.",
      image: coletor2,
    },
    {
      title: "Coletor Solar de Piscina",
      description:
        "Materiais atóxicos não contêm substâncias químicas prejudiciais à saúde, o que significa que não há risco de contaminação da água da piscina por essas substâncias. Além disso, esses materiais são duráveis e resistentes à corrosão, o que reduz a necessidade de manutenção e reparos.",
      image: coletor3,
    },
    {
      title: "Coletor Solar Tubo a Vácuo Acoplado",
      description:
        "O isolamento a vácuo é ALTAMENTE EFICAZ na redução da transferência de calor, pois elimina os mecanismos de transferência de calor condutiva e convectiva. Isso torna-o ideal para aplicações onde a perda ou ganho de calor deve ser minimizado.",
      image: coletor4,
    },
  ],
  "Bombas de Calor": [
    {
      title: "Bomba de Calor Full Inverter",
      description:
        "A Bomba de Calor Full Inverter é perfeita para quem não tem espaço no telhado para um sistema de aquecimento solar. Tantos os modelos maiores quantos os menores podem ser instalados acima ou abaixo do nível da sua piscina, mantendo um dos melhores coeficientes de performance do mercado.",
      image: bomba1,
    },
    {
      title: "Bomba de Calor Para Aquecimento Central",
      description:
        "Com a bomba de calor para aquecimento central, você ESQUENTA E RESFRIA NÃO APENAS A ÁGUA, MAS TAMBÉM O SEU AMBIENTE, criando uma experiência integrada que pode ser controlada remotamente pelo seu aplicativo.",
      image: bomba2,
    },
  ],

  "Bombas de Circulação": [
    {
      title: "Bomba de Circulação TP 20",
      description:
        "Bomba de circulação Komeco ideal para sistemas hidráulicos com água quente e recirculação rápido e estável.",
      image: tp20,
    },
    {
      title: "Bomba de Circulação TP 40",
      description:
        "Bomba de circulação robusta e eficiente, ideal para redes hidráulicas com baixa pressão.",
      image: g4,
    },
    {
      title: "Bomba de Circulação TP 80",
      description:
        "Bomba de circulação com opção em ferro ou bronze e excelente desempenho para pressurização hidráulica. ",
      image: tp80,
    },
    {
      title: "Bomba de Circulação TP 120",
      description:
        "Bomba de circulação TP 120 Komeco com vazão e desempenho superiores para aplicações maiores.",
      image: tp120,
    },
  ],
  "Bombas de piscina": [
    {
      title: "Bomba de Água Aquaflow",
      description:
        "SUA PISCINA CRISTALINA E LIVRE DE IMPUREZAS. Com a linha de bombas Aquaflow, você garante qualidade e confiabilidade no seu sistema de piscina, promovendo uma recirculação de água perfeita e constante.",
      image: bomba3,
    },
    {
      title: "Bomba de Água Aquaflow Connect",
      description:
        "Com a linha de bombas Aquaflow Connect, você garante qualidade e confiabilidade no seu sistema de piscina, promovendo uma recirculação de água perfeita e constante.",
      image: bomba3,
    },
  ],
  "Bombas de Hidromassagem": [
    {
      title: "Bomba de Água de Hidromassagem Aquajet",
      description:
        "São dois modelos disponíveis de 1/2CV e 1CV que podem ser aplicados de acordo com seu projeto. As Bombas Aquajet podem ser instaladas em residências, hotéis e resorts, academias, clubes, centro de saúde e bem estar e mais.",
      image: aquajet,
    },
  ],
  "Lona Térmica": [
    {
      title: "Lona Térmica Para Piscina",
      description:
        "A capa térmica para piscina é um produto especial para piscinas com ou sem sistema de aquecimento. Indicada para proteção e conservação da piscina, a capa possui um shape com bolhas redondas que aumentam o isolamento térmico, reduzindo em até 75% as perdas de calor em uma piscina aquecida.",
      image: lona,
    },
  ],
  "Produtos Texius": [
    {
      title: "SMART 300 • 1/2 CV",
      description:
        "O pressurizador Texius com Inversor de Frequência incorporado ao motor é indicado para pressurização de redes hidráulicas de pequeno e médio porte. Atende ao baixo e medios consumo de água a uma pressão constante, graças ao seu sistema com inversor de frequência.",
      image: smart300,
    },
    {
      title: "SMART PUMP • 1/2 CV, 1 CV e 2 CV",
      description:
        "O pressurizador Texius com Inversor de Frequência incorporado ao motor é indicado para pressurização de redes hidráulicas de pequeno e médio porte. Atende ao baixo e alto consumo de água a uma pressão praticamente constante, graças ao seu sistema com inversor de Frequência.",
      image: smartpump,
    },
    {
      title: "PRESSOSTATO TC-18",
      description:
        "O pressostato eletrônico TC-18 é um equipamento que trabalha em conjunto com um fluxostato interno e é indicado para ser instalado no recalque de motobombas, fazendo com que elas acionem automaticamente sempre que algum ponto de consumo é utilizado.",
      image: pressostato,
    },
    {
      title: "TP-MINI-IP • 80W",
      description: "Pressurização direta dos aquecedores de passagem.",
      image: tpmini,
    },
    {
      title: "TBHLI-70 • 1/2CV",
      description: "Sistemas onde é necessário circular água quente a 80°C.",
      image: tbhl,
    },
  ],
};
/*const productData = {
  Boilers: [
    {
      title: "Reservatório Vertical",
      description:
        "O novo reservatório térmico da Komeco foi projetado para oferecer a você a melhor experiência em aquecimento de água, com foco na praticidade e na durabilidade.",
      image: boiler1,
    },
    {
      title: "Reservatório Horizontal",
      description:
        "Armazene água quente por muito mais tempo e garanta seu banho de conforto e qualidade. Produto Personalizável (consulte nossa equipe para mais informações).",
      image: boiler2,
    },
  ],

  "Aquecedores a Gás": [
    {
      title: "Aquecedor a Gás KO 09B DI Digital",
      description:
        "Aquecedor a gás Komeco com tecnologia digital e painel touchscreen — conforto e eficiência para água quente todos os dias.",
      image:
        "https://www.komeco.com.br/wp-content/uploads/2024/___produto-aquecedor-gas-digital-b-di-2024-komeco-1000x1000px-12.webp",
    },
    {
      title: "Aquecedor a Gás KO 21DI Digital",
      description:
        "Aquecedor a gás Komeco da linha digital, ideal para uso residencial com alta vazão de água quente e excelente desempenho.",
      image:
        "https://www.komeco.com.br/wp-content/uploads/2024/___img-aquecedor-gas-linha-digital-komeco-2024-01.webp",
    },
    // adiciona outros modelos conforme necessidade
  ],

  "Bombas de Pressurização": [
    {
      title: "Pressurizador TP 820 / TP 825 G3",
      description:
        "Pressurizadores Komeco TP 820/825 com acionamento automático e alta eficiência para manter pressão constante na sua rede hidráulica.",
      image:
        "https://www.komeco.com.br/wp-content/uploads/2024/___img-destacada-produto-bomba-tp-820-825-g3-komeco-v02.webp",
    },
    // Pode adicionar imagens específicas de TP 820 ou TP 825 separadamente
  ],

  "Bombas de Circulação": [
    {
      title: "Bomba de Circulação TP 20",
      description:
        "Bomba de circulação Komeco ideal para sistemas hidráulicos com água quente e recirculação rápido e estável.",
      image: tp20,
    },
    {
      title: "Bomba de Circulação TP 40",
      description:
        "Bomba de circulação robusta e eficiente, ideal para redes hidráulicas com baixa pressão.",
      image: g4,
    },
    {
      title: "Bomba de Circulação TP 80",
      description:
        "Bomba de circulação com opção em ferro ou bronze e excelente desempenho para pressurização hidráulica. ",
      image: tp80,
    },
    {
      title: "Bomba de Circulação TP 120",
      description:
        "Bomba de circulação TP 120 Komeco com vazão e desempenho superiores para aplicações maiores.",
      image: tp120,
    },
  ],

  "Bombas de Piscina": [
    {
      title: "Bomba de Piscina Aquaflow Connect",
      description:
        "Bomba de piscina Komeco Aquaflow Connect com sistema inteligente de controle e alta eficiência.",
      image:
        "https://www.komeco.com.br/wp-content/uploads/2024/___produto-bomba-aquaflow-connect-komeco.webp",
    },
    {
      title: "Bomba de Piscina Aquaflow",
      description:
        "Bomba de piscina Komeco Aquaflow para recirculação perfeita da água com confiabilidade.",
      image:
        "https://www.komeco.com.br/wp-content/uploads/2024/___produto-bomba-aquaflow-komeco.webp",
    },
  ],

  "Bombas de Hidromassagem": [
    {
      title: "Bomba de Hidromassagem Aquajet 1/2CV",
      description:
        "Bomba de hidromassagem Aquajet 1/2CV — perfeita para banheiras e espaços de relaxamento.",
      image: "",
    },
    {
      title: "Bomba de Hidromassagem Aquajet 1CV",
      description:
        "Bomba de hidromassagem Aquajet 1CV com mais potência e desempenho para ambientes de spa.",
      image: "",
    },
  ],

  "Coletores Solares": [
    {
      title: "Coletor Solar Tubo a Vácuo Baixa Pressão",
      description:
        "O Coletor Solar Tubo a Vácuo de Baixa Pressão é responsável por elevar a temperatura da água a um nível agradável para o banho.",
      image: coletor1,
    },
    {
      title: "Coletor Solar Tubo a Vácuo Alta Pressão",
      description:
        "O Coletor Solar Tubo a Vácuo de Alta Pressão é responsável por elevar a temperatura da água a um nível agradável para o banho.",
      image: coletor2,
    },
    {
      title: "Coletor Solar de Piscina",
      description:
        "Materiais atóxicos não contêm substâncias químicas prejudiciais à saúde.",
      image: coletor3,
    },
    {
      title: "Coletor Solar Tubo a Vácuo Acoplado",
      description:
        "O isolamento a vácuo é altamente eficaz na redução da transferência de calor.",
      image: coletor4,
    },
  ],

  "Bombas de Calor": [
    {
      title: "Bomba de Calor Full Inverter",
      description:
        "A Bomba de Calor Full Inverter é perfeita para quem não tem espaço no telhado, oferecendo aquecimento eficiente durante o ano todo.",
      image: "",
    },
  ],
};
*/
const ProductTabs = () => {
  const categories = Object.keys(productData);
  const [activeTab, setActiveTab] = useState(categories[0]);
  const [animate, setAnimate] = useState(true);

  const handleTabClick = (tab) => {
    setAnimate(false);
    setTimeout(() => {
      setActiveTab(tab);
      setAnimate(true);
    }, 100); // short delay for animation trigger
  };

  return (
    <>
      <div
        style={{ marginTop: 20, color: "#2165f7" }}
        className="section-header text-center mb-4"
      >
        <img src={Logo} height={50} alt="ThermalHydro" />
        <h2 style={{ marginTop: 20 }}>Nossos Produtos</h2>
      </div>
      <div className="product-tabs-container">
        <aside className="menu">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => handleTabClick(cat)}
              className={cat === activeTab ? "active" : ""}
            >
              {cat}
            </button>
          ))}
        </aside>

        <div className={`products ${animate ? "animate-in" : ""}`}>
          {productData[activeTab].length > 0 ? (
            productData[activeTab].map((prod, i) => (
              <div className="product-card" key={i}>
                <img src={prod.image} alt={prod.title} />
                <h3>{prod.title}</h3>
                <div className="underline" />
                <p>{prod.description}</p>
                <a
                  href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+produtos+de+${prod.title}.`}
                  target="_blank"
                  style={{ color: "inherit" }}
                >
                  <button className="view-btn">SAIBA MAIS</button>
                </a>
              </div>
            ))
          ) : (
            <p className="empty">
              Nenhum produto cadastrado para esta categoria.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductTabs;
